import { UserType } from '../constants/constants';
import { IMatterRequest } from '../interface/matterRequest';
import { IUserGroup } from '../interface/user';

interface IMatterRequestPermissionParams {
  matterRequest: IMatterRequest | undefined;
  userId: string | undefined;
  userType: string | undefined;
}

interface ICanEditMatterRequestPeopleParams extends IMatterRequestPermissionParams {
  assistantMayModifyUserRights: boolean;
  isExtendedRightsGroupMember: boolean;
}

const isOwnerOrResponsible = ({ matterRequest, userId }: IMatterRequestPermissionParams) =>
  Boolean(userId) &&
  (matterRequest?.ownerUserId === userId || matterRequest?.responsibleUserId === userId);

const isAssistant = ({ matterRequest, userId }: IMatterRequestPermissionParams) =>
  Boolean(userId) && matterRequest?.assistantUserId === userId;

const isInvoicingContact = ({ matterRequest, userId }: IMatterRequestPermissionParams) =>
  Boolean(userId) && matterRequest?.invoicingUserId === userId;

/** A record without the insider flag is not treated as normal, so a field that was not loaded never widens access. */
const isNormalMatterRequest = ({ matterRequest }: IMatterRequestPermissionParams) =>
  matterRequest?.insider === false;

export const isUserInGroup = (
  userGroups: IUserGroup[] | undefined,
  groupId: string | null | undefined,
): boolean => {
  if (!groupId) return false;
  return new Set(userGroups?.map(({ userGroupId }) => userGroupId)).has(groupId);
};

export const canEditMatterRequestPeople = ({
  assistantMayModifyUserRights,
  isExtendedRightsGroupMember,
  ...params
}: ICanEditMatterRequestPeopleParams): boolean => {
  if (params.userType === UserType.ADMIN || isOwnerOrResponsible(params)) return true;
  if (isNormalMatterRequest(params)) {
    return isAssistant(params) || isInvoicingContact(params) || isExtendedRightsGroupMember;
  }
  return assistantMayModifyUserRights && isAssistant(params);
};
